import React from 'react';
import { withLogger } from '../../appContext/LoggerProvider';
import { Text } from '../PageElements/Text';

function FallbackComponent() {
  return (
    <Text dataHook="fallbackUi">
      An error occurred while trying to present this content. Please try again
      later!
    </Text>
  );
}
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      error: false,
    };
  }

  componentDidCatch(error) {
    console.error(error);
    window && window.Sentry.captureException(error);
    this.setState({ error: true });
  }

  render() {
    return this.state.error
      ? this.props.fallbackUi || <FallbackComponent />
      : this.props.children;
  }
}

export default withLogger(ErrorBoundary);
